import {
    ApiHandler,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    CustomShareEntityModel,
    submitCustomShareEntity,
    submitOrderDetailsShareEntity,
} from "@tKgpco/Services/CustomShareEntityService";

export interface CustomShareEntityParameter {
    customShareEntityModel: CustomShareEntityModel;
    onSuccess?: () => void;
}

type HandlerType = ApiHandler<CustomShareEntityParameter, CustomShareEntityModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        customShareEntityModel: props.parameter.customShareEntityModel,
    };
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult =
        props.apiParameter.customShareEntityModel?.type === "Order"
            ? await submitOrderDetailsShareEntity({
                  emailFrom: props.apiParameter.customShareEntityModel.emailFrom,
                  emailTo: props.apiParameter.customShareEntityModel.emailTo,
                  entityId: props.apiParameter.customShareEntityModel.entityId,
                  entityName: props.apiParameter.customShareEntityModel.entityName,
                  message: props.apiParameter.customShareEntityModel.message,
                  subject: props.apiParameter.customShareEntityModel.subject,
              })
            : await submitCustomShareEntity({
                  emailFrom: props.apiParameter.customShareEntityModel.emailFrom,
                  emailTo: props.apiParameter.customShareEntityModel.emailTo,
                  entityId: props.apiParameter.customShareEntityModel.entityId,
                  entityName: props.apiParameter.customShareEntityModel.entityName,
                  message: props.apiParameter.customShareEntityModel.message,
                  subject: props.apiParameter.customShareEntityModel.subject,
              });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const customShareEntity = createHandlerChainRunner(chain, "CustomShareEntity");
export default customShareEntity;
